import SponsoredProducts from './SponsoredProducts.component';

export default SponsoredProducts;